export type PlanStatus = "ACTIVE" | "INACTIVE" | "DRAFT" | "ARCHIVED";

export const PLAN_STATUSES: PlanStatus[] = [
  "ACTIVE",
  "INACTIVE",
  "DRAFT",
  "ARCHIVED",
];

export interface SubscriptionFeatureDefinition {
  id: string;
  key: string;
  title: string;
  type: string;
  limit?: unknown;
}

export interface SubscriptionPlanFeature {
  id?: string;
  planId?: string;
  featureId: string;
  value?: string;
  createdAt?: string;
  limit?: unknown;
  feature?: SubscriptionFeatureDefinition;
  key?: string;
  title?: string;
  type?: string;
}

export interface SubscriptionPlan {
  id: string;
  title: string;
  description: unknown;
  price: number | string;
  currency: string;
  stripePriceId: unknown;
  isDefault: boolean;
  isCustom: boolean;
  enableCoreFeatures?: boolean;
  tenantId: unknown;
  status: string;
  features: SubscriptionPlanFeature[];
  createdAt: string;
  updatedAt: string;
}

export interface ListSubscriptionPlansQuery {
  status?: PlanStatus;
  isDefault?: boolean;
}

export interface PlanFeatureValuePayload {
  featureId: string;
  value: string;
}

export interface CreateSubscriptionPlanPayload {
  title: string;
  description?: string;
  price: number;
  currency?: string;
  stripePriceId?: string;
  isDefault?: boolean;
  enableCoreFeatures?: boolean;
  features?: PlanFeatureValuePayload[];
}

export interface UpdateSubscriptionPlanPayload {
  title?: string;
  description?: string;
  price?: number;
  currency?: string;
  stripePriceId?: string;
  isDefault?: boolean;
  enableCoreFeatures?: boolean;
  status?: PlanStatus;
  features?: PlanFeatureValuePayload[];
}
